<template>
  <div class="guard-features-grid" v-if="features.length">
    <CompanyFeatureCard
      v-for="feature in features"
      :key="feature.id"
      :name="feature.name"
      :logo="feature.logo"
      @click="$emit('select-feature', feature)"
    />
  </div>
  <div class="guard-features-empty" v-else>
    <svg class="guard-features-empty__icon" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12h8" stroke-linecap="round" />
    </svg>
    <p class="guard-features-empty__title">No hay opciones disponibles</p>
    <p class="guard-features-empty__subtitle">Si necesitas ayuda, llama a recepción.</p>
  </div>
</template>

<script>
import CompanyFeatureCard from "./CompanyFeatureCard.vue";

export default {
  name: "CompanyFeatures",
  components: { CompanyFeatureCard },
  props: {
    features: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '../styles';

.guard-features-grid { @include guard-tiles-grid; }

.guard-features-empty {
  @include guard-responsive-width;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2.5rem 1rem;
  gap: 0.5rem;

  &__icon {
    width: 3rem;
    height: 3rem;
    stroke: $guard-ink-400;
    fill: none;
    stroke-width: 1.5;
    opacity: 0.6;
    margin-bottom: 0.3rem;
  }
  &__title {
    font-size: 1rem;
    font-weight: 600;
    color: $guard-ink-600;
    margin: 0;
  }
  &__subtitle {
    font-size: 0.85rem;
    color: $guard-ink-400;
    margin: 0;
  }
}
</style>